import { ContentMessage, ModalDialog } from 'axway-react-ui';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import browserHistory from 'components/utility/history';

class GenerateEndpointsDialog extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.closeDialog = this.closeDialog.bind(this);
		this.generateEndpoints = this.generateEndpoints.bind(this);
		this.redirectToAPIListView = this.redirectToAPIListView.bind(this);
		this.model = props.model;
		this.errorCtx = [
			this.intl.formatMsg('Not found', 'error.title.GENERATE_ENDPOINTS.generic'),
			this.intl.formatMsg('The model name was not provided', 'error.summary.GENERATE_ENDPOINTS')
		];
	}

	closeDialog() {
		this.props.closeDialog();
	}

	generateEndpoints() {
		this.props.generateEndpoints();
	}

	redirectToAPIListView() {
		this.closeDialog();
		const id = encodeURIComponent(this.props.endpointLocation);
		browserHistory.push(`${window.$conf.prefix}/project/apidocs/${id}`);
	}

	render() {
		if (this.props.modelForEndpoint && this.props.modelForEndpoint.name) {
			const sourceMsg = this.intl.formatMsg('you should have your source committed to source control before continuing');
			const apiFirst = this.intl.formatMsg('API-first methodologies');

			return (
				<ModalDialog
					dialogClassName="generate-api-modal"
					title={this.intl.formatMsg('You are about to generate an API')}
					okayText={this.intl.formatMsg('Proceed')}
					closeText={this.intl.formatMsg('Cancel API generation')}
					onClose={this.closeDialog}
					onOkay={this.generateEndpoints}
					validateOnOkay={false}
					show
				>
					<div className="gg icon-GG-warning" aria-hidden="true" />
					<div>
						<p>
							{this.intl.formatHTMLMsg('This will generate an OpenAPI specification for the model and flows that use the model for CRUD operations. The OpenAPI specification should be managed using {href}.', { href: <a target="_blank" rel="noreferrer" href={window.$conf.docManageSpecs}>{apiFirst}</a> })}
						</p>
						<p>
							{this.intl.formatHTMLMsg('This feature can overwrite existing files in your project, so {message}.', { message: <b>{sourceMsg}</b> })}
						</p>
						<p>
							{this.intl.formatMsg('Once generated, the OpenAPI specification is not kept in sync with the model, and any changes to the model will need to be reciprocated in the OpenAPI specification.')}
						</p>
					</div>
				</ModalDialog>
			);
		} else if (this.props.generateSuccess === true) {
			return (
				<ContentMessage
					className="generate-endpoints success"
					confirm
					onClose={this.closeDialog}
					summary={this.intl.formatMsg('Success! API have been generated.')}
					imgClass="gg icon-GG-file-check"
					onAction={this.redirectToAPIListView}
					actionLabel={this.intl.formatMsg('Go to API details')}
				/>
			);
		}
		return null;
	}
}

GenerateEndpointsDialog.propTypes = {
	modelForEndpoint: PropTypes.object,
	generateSuccess: PropTypes.bool,
	endpointLocation: PropTypes.string.isRequired,
	closeDialog: PropTypes.func.isRequired,
	generateEndpoints: PropTypes.func.isRequired
};

GenerateEndpointsDialog.defaultProps = {
	modelForEndpoint: null,
	generateSuccess: false
};

export default injectIntl(GenerateEndpointsDialog);
